import React, { useMemo, useState } from "react";
import JudScore from "./JudScore";
import JudPbp from "./JudPbp";
import Card from 'react-bootstrap/Card';
import { findArray } from 'helpers/utils';
import Referees from "components/general/Referees";

const CardSubMatches = ({ matches, parentData }) => {


  return (
    matches.map((match, index) => {
      //let phaseWithUnits = getPhaseRSC(dataPool?.data?.poolStandings?.rsc);
      let category = findArray(findArray(parentData, { ei_value: [match?.data?.results?.eventUnitCode] })?.extensions, { eie_code: ['WEIGHT_CATEGORY'] })?.eie_value;
      return (
        <Bloque key={'bloque-' + index} data={match?.data} category={category} ></Bloque>
      )
    })
  )
}

const JudSubMatch = ({ matches, parentData }) => {

  return (
    <>
      <Card className="text-center" bg='gray' text='light'>
        <Card.Body>
          <Card.Title>Contests</Card.Title>
        </Card.Body>
      </Card>
      <CardSubMatches matches={matches} parentData={parentData} />
    </>
  )
}



const Bloque = ({ data, category }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <JudScore data={data} category={category} handleClick={setOpen} state={open} />
      {open && <><JudPbp data={data} /> <Referees data={data?.results?.officials} /></>}
    </>
  )
}



export default JudSubMatch;